/**
 * sortProgrammesByUniversityThenPriority
 * ──────────────────────────────────────
 * Sorting policy for the student-facing programme list. Groups programmes
 * by their university first, then orders within each group by priority
 * (1ª escolha before 2ª).
 *
 * Old behaviour: `orderBy priority asc` mixed universities together
 * (UEM-1ª, ISCAM-1ª, UEM-2ª, ISCAM-2ª). The new policy reads more
 * naturally to a Mozambican student thinking "what UEM courses do I
 * have, then what ISCAM ones?"
 *
 * Universities are sorted alphabetically by short_name so the order is
 * deterministic across reloads.
 *
 * Generic on the row shape so admin / profile / context-switcher can
 * all reuse it without forcing a single TypeScript shape.
 */

interface MinimalProgrammeRow {
  priority: number
  programme: { university: string | { short_name: string } }
}

export function sortProgrammesByUniversityThenPriority<T extends MinimalProgrammeRow>(rows: T[]): T[] {
  return [...rows].sort((a, b) => {
    const ua = typeof a.programme.university === 'string'
      ? a.programme.university
      : a.programme.university.short_name
    const ub = typeof b.programme.university === 'string'
      ? b.programme.university
      : b.programme.university.short_name
    const u = ua.localeCompare(ub)
    if (u !== 0) return u
    return a.priority - b.priority
  })
}
